/**
 * Set when retailer interacts the ACH PLI offer promo modals and banners *
 */ export var HAS_SEEN_ACH_PROACTIVE_LIMIT_INCREASE_MODAL = 'HAS_SEEN_ACH_PROACTIVE_LIMIT_INCREASE_MODAL';
